import { Injectable } from "@angular/core";

import { tags } from "@lezer/highlight";
import { Extension, Prec } from "@codemirror/state";
import { HighlightStyle, syntaxHighlighting } from "@codemirror/language";

import { CodeEditorThemeService } from "../../services/code-editor-theme.service";


@Injectable()
export class HtmlEditorThemeService {

    constructor(private themeService: CodeEditorThemeService) {
    }

    public getThemeExtension(): Extension {

        const theme: Extension[] = this.themeService.getThemeExtension();

        const highlightStyle: Extension = this.getHighlightStyleExtension();

        return [...theme, highlightStyle];
    }

    public getHighlightStyleExtension(): Extension {
        const style: HighlightStyle = HighlightStyle.define([
            { tag: tags.name, color: "#c191ff" }, // Make identifiers strings magenta.
            { tag: tags.angleBracket, color: "#c191ff" }, // Make angle tags strings magenta.
            { tag: tags.attributeName, color: "#85c46c" }, // Make attribute names olive-green.
            { tag: tags.attributeValue, color: "#c9a26d" }, // Make attribute values brown.
            { tag: tags.propertyName, color: "#e06c75" }, // Make attribute values red.
            { tag: tags.keyword, color: "inherit" }, // Make keywords inherit color.
        ])
        return Prec.high(syntaxHighlighting(style));
    }
}